export default "__VITE_PUBLIC_ASSET__2e37f91d__"